import {Sidebar}  from './Sidebar';

const swipingDefaults = () => ({
    started: false,
    startX: null,
    startY: null,
    movedX: 0,
    movedY: 0,
    direction: null,
    element: null
});

let swiping = swipingDefaults();

const startTouch = e => {
    swiping.started = true;
    swiping.startX  = e.touches[0].clientX;
    swiping.startY  = e.touches[0].clientY;
    swiping.element = e.target;
};

const moveTouch = e => {
    swiping.direction = swiping.startX < e.touches[0].clientX ? 'right' : 'left';
    swiping.movedX    = Math.abs(swiping.startX - e.touches[0].clientX);
    swiping.movedY    = Math.abs(swiping.startY - e.touches[0].clientY);
}

const isSwipeOnValidTarget = (target) => {
    const swipeTargets = [
        document.querySelector('main > .content'),
        document.querySelector('body > .mask'),
        document.querySelector('nav.sidebar'),
    ];

    return swipeTargets.some((swipeTarget) => swipeTarget && swipeTarget.contains(target));
};

const isValidSwipe = () => {
    if (!swiping.started) {
        return false;
    }

    if (!isSwipeOnValidTarget(swiping.element)) {
        return false;
    }

    if (swiping.direction === 'right' && swiping.startX > 80) {
        return false;
    }

    if (swiping.movedX < 30) {
        return false;
    }

    if (swiping.movedY > swiping.movedX) {
        return false;
    }

    if (swiping.direction === 'left' && !document.querySelector('nav.sidebar').classList.contains('active')) {
        return false;
    }

    if (swiping.direction === 'right' && document.querySelector('nav.sidebar').classList.contains('active')) {
        return false;
    }

    return true;
};
const endTouch = () => {
    if (!isValidSwipe()) {
        swiping = swipingDefaults();

        return;
    }

    if (swiping.direction === 'left') {
        Sidebar.close();
    } else {
        Sidebar.open();
    }

    swiping = swipingDefaults();
};

addEventListener('touchstart', startTouch);
addEventListener('touchmove', moveTouch);
addEventListener('touchend', endTouch);

